import React, { useState } from "react";
import { TextField } from "@mui/material";
import { Form } from "react-bootstrap";
import { server } from "../../common";
import { toast } from "react-toastify";

const Volunteer = () => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!fullname.trim() || !email.trim() || !message.trim()) {
      toast.warning("Please fill out all the fields properly.");
      return;
    }

    setLoading(true);
    try {
      const response = await server.post("/volunteer/addvolunteer", {
        fullname: fullname.trim(),
        email: email.trim(),
        message: message.trim(),
      });

      if (response.status === 201 || response.status === 200) {
        toast.success("Thank you! Your volunteer application has been submitted successfully.");
        setFullname("");
        setEmail("");
        setMessage("");
      } else {
        toast.error(response.data?.message || "Failed to submit application.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to connect to the server. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="row ">
        <div className="col-md-6">
          <div className="text-center">
            <img src="/images/volunteer.jpeg" className="img-fluid" alt="" />
          </div>
        </div>

        <div className="col-md-6 align-self-center my-3">
          <div className=" justify-content-center">
            <h3>BECOME A VOLUNTEER</h3>
            <Form onSubmit={handleSubmit}>
              <TextField
                name="fullname"
                margin="dense"
                type="text"
                placeholder="Enter Your First Name"
                variant="outlined"
                label="Name"
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
                fullWidth
                required
              ></TextField>

              <TextField
                name="email"
                margin="dense"
                type="email"
                placeholder="Enter Your Email ID"
                variant="outlined"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
              ></TextField>

              <TextField
                name="message"
                margin="dense"
                type="text"
                placeholder="Message"
                variant="outlined"
                label="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
                multiline
                rows={3}
                required
              ></TextField>

              <button
                type="submit"
                className="px-3 my-1 btn btn-success text-white "
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Volunteer;
